import { familyTypeKey, formatFamilyType } from '@messenger/utils'
import { replaceInitialValues } from 'utils/tinyMCE/replaceInitialValues'
import getThemeStylesForTemplate from 'utils/tinyMCE/templates/getThemeStylesForTemplate'
import { buildFieldsString } from 'utils/tinyMCE/buildFieldsString'
import { buildAdditionalFamilyContent } from 'utils/tinyMCE/caseDetails/buildAdditionalFamilyContent'
import { insertTemplate } from 'utils/tinyMCE/insertMenu/insertTemplate'
import addSpansToParagraphs from 'utils/tinyMCE/updateDynamicText/addSpansToParagraphs'

// Field keys for family member data — the original static-insert field list.
const familyFieldKeys = ['name', 'relation', 'city', 'state', 'country']

/**
 * M3 orders get the single "Additional Family" item inserting one dynamic
 * block (data-case-detail="additional_family") that re-renders on sidebar
 * edits. MDL orders keep the original behavior: one static-text menu item
 * per family-type group. Gated on editor.customData.isM3Order (set by the
 * TinyMCE component from useIsM3Order — product-source-derived, so master
 * orders opened from MDL with M3 products qualify too).
 */
export const handleAdditionalFamily = (
  editor,
  caseDetails,
  key,
  templates,
  dateFormat,
  selectedTheme,
) => {
  const themeStyles = getThemeStylesForTemplate({ selectedTheme, editor })
  const isM3Order = editor?.customData?.isM3Order === true

  if (isM3Order) {
    templates.push({
      type: 'menuitem',
      text: 'Additional Family',
      onAction: () => {
        const blockContent = `&#8202;<div class="mceNonEditable" data-case-detail="additional_family" style="${themeStyles}">${buildAdditionalFamilyContent(caseDetails[key])}</div>&#8202;`
        const contentWithSpans = addSpansToParagraphs(
          blockContent,
          'font-size: 11pt;' + themeStyles,
        )
        insertTemplate(editor, contentWithSpans)
      },
    })
    return
  }

  // MDL: original per-type static inserts. Group case-insensitively — the
  // DB is standardized to lowercase, but legacy casing may still appear in
  // unsaved in-memory data.
  const groupedByType = Object.values(
    caseDetails[key].reduce((acc, obj) => {
      const groupKey = familyTypeKey(obj.type)
      if (!acc[groupKey]) {
        acc[groupKey] = { type: obj.type, items: [] }
      }
      acc[groupKey].items.push(obj)
      return acc
    }, {}),
  )

  groupedByType.forEach((group) => {
    let content = ''

    group.items.forEach((item) => {
      const familyFields = buildFieldsString(item, familyFieldKeys)
      if (familyFields) {
        content += `
        <p style="${themeStyles}">
            ${familyFields}
        </p><br/>
      `
      }
    })

    templates.push({
      type: 'menuitem',
      text: `${formatFamilyType(group.type)}`,
      onAction: () =>
        editor.execCommand(
          'mceInsertTemplate',
          false,
          replaceInitialValues(content, caseDetails),
        ),
    })
  })
}

export default handleAdditionalFamily
